module.exports = __webpack_public_path__ + "static/img/default-avatar.df65eed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default-avatar.svg
// module id = /iTu
// module chunks = 1